import { MessageAlertOutlineIcon } from './MessageAlertOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 3487FE3E-2B9B-4C69-B64C-B3E699E9EC8C
 * name message-alert-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const MessageWarningOutlineIcon = MessageAlertOutlineIcon;
export default MessageWarningOutlineIcon